import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ServiceBase } from '../service.base';
import { AuthService, ResponseObject } from '../auth.service';
import { PlateformCurrencyExchangeRate } from '../Wix-Service/wix.service';
import { GalleryConsignmentProduct } from '../consignment.service';



@Injectable({
    providedIn: 'root'
})
export class SquareupPosService extends ServiceBase {

    public api = '/SquareUp';
    constructor(private http: HttpClient,
        authService: AuthService) {
        super(authService);
    }

    public connectWithPosAccount(): Observable<ResponseObject> {
        const httpOptions = this.RequestHeaders();
        const method: string = '/login-with-square';
        const url: string = environment.BASE_API_PATH + this.api + method;
        return this.http.get<ResponseObject>(url, httpOptions);
    }

    public getArtworkSynchronizationPermission() {
        const httpOptions = this.RequestHeaders();
        const api = '/User'
        const method: string = '/sync-permissions';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.get<SyncArtworkPermission>(url, httpOptions);
    }

    public updateArtworkSynchronizationPermission(data: SyncArtworkPermission) {
        const httpOptions = this.RequestHeaders();
        const api = '/User'
        const method: string = '/update-sync-permission';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, data, httpOptions);
    }

    public allowProductSyncOnSquareUp() {
        const httpOptions = this.RequestHeaders();
        const method: string = '/sqaureUp-product-synced';
        const url: string = environment.BASE_API_PATH + this.api + method;
        return this.http.get<boolean>(url, httpOptions);
    }

    public hasAccountOnSquareUp() {
        const httpOptions = this.RequestHeaders();
        const method: string = '/account-exists';
        const url: string = environment.BASE_API_PATH + this.api + method;
        return this.http.get<SquareUpOAuthTokken>(url, httpOptions);
    }

    public getConnectedPosAccount(): Observable<PosAccount> {
        const httpOptions = this.RequestHeaders();
        const method: string = '/fetch-square-pos-business-details';
        const url: string = environment.BASE_API_PATH + this.api + method;
        return this.http.get<PosAccount>(url, httpOptions);
    }

    public onConnectWithPosAccountCallBack(code: string, state: string): Observable<ResponseObject> {
        const method: string = '/store-token-callback';
        const url: string = `${environment.BASE_API_PATH}${this.api}${method}/${code}/${state}`;
        const httpOptions = this.RequestHeaders();
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

    public onDisConnectWithPosAccount(): Observable<ResponseObject> {
        const method: string = '/Disconnect-Account';
        const url: string = environment.BASE_API_PATH + this.api + method;
        const httpOptions = this.RequestHeaders();
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }



    public onProductSyncsquareUp(consignmentId: string, productId: string ,IsUserAddManullyRates: boolean): Observable<ResponseObject> {
        const httpOptions = this.RequestHeaders();
        const method = `/sync-single-product/${consignmentId}/${productId}/${IsUserAddManullyRates}`;
        const url = environment.BASE_API_PATH + this.api + method;
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

     public storeCurrencyofsquareUpWithExchangeRate():Observable<PlateformCurrencyExchangeRate> {
        const httpOptions = this.RequestHeaders();
        const method: string = '/fetch-store-currency-with-exchangeRate';
        const url: string = environment.BASE_API_PATH + this.api + method;
        return this.http.get<PlateformCurrencyExchangeRate>(url, httpOptions);
      }

      public getSquareupSyncProducts(): Observable<GalleryConsignmentProduct[]> {
        const httpOptions = this.RequestHeaders();
        const method: string =  '/fetch-synced-products';
        const url: string = environment.BASE_API_PATH + this.api + method;
        return this.http.get<GalleryConsignmentProduct[]>(url, httpOptions);
      }

}


export interface PosAccount {
    location: Location[];
    SquarePOSTokkenExpireAt: string;
    SquarePOSLoggedInAt: string;
    responseObject: ResponseObject;
}

export interface Location {
    id: string;
    name: string;
    address: Address;
    timezone: string;
    capabilities: string[];
    status: string;
    created_at: Date;
    merchant_id: string;
    country: string;
    language_code: string;
    currency: string;
    business_name: string;
    type: string;
    website_url: string;
    business_hours: BusinessHours;
    business_email: string;
    description: string;
    instagram_username: string;
    facebook_url: string;
    logo_url: string;
    mcc: string;
    full_format_logo_url: string;
}

export interface Address {
    address_line_1: string;
    address_line_2: string;
    locality: string;
    administrative_district_level_1: string;
    postal_code: string;
    country: string;
}

export interface BusinessHours {
}

export class SquareUpOAuthTokken {
    Id!: string;
    CreatedAt!: Date;
}

export class SyncArtworkPermission {
    IsSyncToSquarePos!: boolean
    IsSyncToShopify!: boolean
    IsSyncToWooCommerce!: boolean
    IsSyncToWix!: boolean

}



